@if (medewerker$ | async; as medewerker) {
	<div class="dashboard-toets">
		<app-filter-bar></app-filter-bar>
		<app-filter-panel
			[defaultFilters]="toetsFilters"
			[allFilters]="allFilters()"
			[leerlingselectie]="false"
			(filterExpressionsChange)="filterExpressions.set($event)"
			endpoint="/cijfers"
			[permanentFilterExpressions]="getDashboardFilters(permanentFilters(), medewerker.medewerker)"
			[overrideDefault]="getSchooljaarFilterOverride(medewerker.schooljaarInfo)"
		></app-filter-panel>
		<section class="dashboard">
			<app-dashboard-header>
				<app-single-select-dropdown
					label="Cijfertype"
					[opties]="cijferkolomKeuzeOpties()"
					[selectedOptie]="getSelectedCijfertypeOptie()"
					(onOptieClicked)="qp.dispatch('cijfertype', $event)"
				></app-single-select-dropdown>
				@if (cijferkolomKeuze() !== CijferkolomKeuze.GEMIDDELDE && userService.bron() === InstellingBron.Somtoday) {
					<app-single-select-dropdown
						label="Toetsdossier"
						[opties]="dossierOpties"
						[selectedOptie]="getSelectedDossierOptie()"
						(onOptieClicked)="qp.dispatch('dossier', $event)"
					></app-single-select-dropdown>
				}
				<app-legenda class="cl-header-utility" [attribute]="['cf_nr_cijfer_afgerond']"></app-legenda>
			</app-dashboard-header>
			@if (medewerker) {
				<app-pivot-table
					[filters]="filterExpressions()"
					[permanentFilters]="getDashboardFilters(permanentFilters(), medewerker.medewerker)"
					[tableGroups]="tableGroups"
					[groups]="groeperingService.huidigeGroeperingen()"
					[subgroups]="subgroups"
					[columnSort]="sortToetsKolommen"
					[config]="this"
				></app-pivot-table>
			}
		</section>
	</div>
}
